export default "__VITE_ASSET__j3gI9wMp__"